import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-chart-column h-4 w-4 shrink-0",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }, null, -1),
    _createElementVNode("path", { d: "M18 17V9" }, null, -1),
    _createElementVNode("path", { d: "M13 17V5" }, null, -1),
    _createElementVNode("path", { d: "M8 17v-3" }, null, -1)
  ]))]))
}